import template from "./hb-avatar.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import { Me } from "../../managers/Me";
import {
    getName,
    getRandomAvatarUrl,
    getAuraColor,
    getKiitosAuraColor,
    getKiittiAuraColor,
    getKiitosAuraSize,
    getKiittiAuraSize
} from "../global";
import { HeartBank } from "../../managers/HeartBank";
import { Kiitti } from "../../models/Kiitti";
import { Tokens } from "../../models/Thanks";
import { Functions } from "../../managers/Functions";
import { HbMain } from "../hb-main/hb-main";

const avatar = new URL("../../public/avatar.webp", import.meta.url).href;

export class HbAvatar extends HTMLElement {
    private heartbank = new HeartBank();
    private functions = new Functions();
    private kiitti = new Kiitti();
    private tokens = new Tokens();
    private me = new Me();
    private main = document.querySelector("hb-main") as HbMain;

    private avatarYes: HTMLElement;
    private yesAqua: HTMLElement;
    private photo: HTMLImageElement;
    private name: HTMLHeadingElement;

    //private avatarNo: HTMLElement;
    //private noAqua: HTMLElement;
    //private auraCircle: SVGCircleElement;

    constructor() {
        super();
        render(template, this);

        this.avatarYes = this.querySelector("#hb-avatar-yes")!;
        this.yesAqua = this.querySelector("#hb-avatar-yes-aqua")!;
        // this.avatarNo = this.querySelector("#hb-avatar-no")!;
        // this.auraCircle = this.avatarNo.querySelector(
        //     "circle"
        // ) as SVGCircleElement;
        // this.noAqua = this.querySelector("#hb-avatar-no-aqua")!;
        this.photo = this.querySelector("#hb-avatar-photo")!;
        this.name = this.querySelector("#hb-avatar-name")!;
    }

    connectedCallback() {
        this.avatarYes.addEventListener("click", async () => {
            if (
                confirm(
                    "⚡️ Would you like a Happiness Energy Boost for your ❤️ ?"
                )
            ) {
                this.main.showSpinner();
                const token = await this.tokens.getChest(
                    this.heartbank.user?.uid || ""
                );
                if (token.cursor) window.tokenCursor = token.cursor;
                this.main.hideSpinner();

                if (token.data) {
                    history.pushState(null, "", `#/token/${token.data.id}`);
                    this.main.showToken(token.data, "", "0", false);
                    //window.location.hash = `#/token/${token.data.id}`;
                } else
                    alert(`⚡️ Happiness Energy Boost for your ❤️ coming soon!`);

                const name = this.heartbank.user
                    ? await this.me.getName3(this.heartbank.user.uid)
                    : "Someone";
                this.functions.admin(
                    "⚡️ Happiness Energy Boost",
                    `❤️‍🔥 ${name} has received a Happiness Energy Boost!`
                );
            } else {
                this.main.showSpinner();
                const moment = await this.kiitti.getRock(
                    this.heartbank.user?.uid || ""
                );
                if (moment.cursor) window.momentCursor = moment.cursor;
                this.main.hideSpinner();

                if (moment.data) {
                    history.pushState(null, "", `#/aquarius/${moment.data.id}`);
                    this.main.showDear(moment.data, false);
                    //window.location.hash = `#/aquarius/${moment.data.id}`;
                } else
                    alert(`⚡️ Positive Energy Boost for your ❤️ coming soon!`);

                const name = this.heartbank.user
                    ? await this.me.getName3(this.heartbank.user.uid)
                    : "Someone";
                this.functions.admin(
                    "⚡️ Positive Energy Boost",
                    `❤️‍🔥 ${name} has received a Positive Energy Boost!`
                );
            }

            // const moment = await this.kiitti.getRock(
            //     this.heartbank.user?.uid || ""
            // );
            // if (moment.cursor) window.tokenCursor = moment.cursor;
            // window.location.hash = moment.data
            //     ? `#/aquarius/${moment.data.id}`
            //     : "#/aquarius";
        });

        // this.heartbank.addAuthStateListener((user) => {
        //     this.render(user);
        // });
    }

    // attribute names are case-insensitive in HTML
    static get observedAttributes() {
        return [
            "uid", // uid or ""
            "aura", // rainbow
            "circle", // membership level: "silver", "mithril", "gold", "platinum"
            "ring", // aqua: none, cash, iou // gray, indigo
            "token" // none, kiitos, kitti, cash, stablecoin
        ];
    }

    get uid(): string {
        return this.getAttribute("uid") ?? "";
    }

    set uid(value: string) {
        this.setAttribute("uid", value);
    }

    get aura(): string {
        return this.getAttribute("aura") ?? "silver"; // default silver
    }

    set aura(value: string) {
        this.setAttribute("aura", value);
    }

    get ring(): string {
        return this.getAttribute("ring") ?? "none";
    }

    set ring(value: "none" | "cash" | "iou") {
        this.setAttribute("ring", value);
    }

    get circle(): string {
        return this.getAttribute("circle") ?? "gray";
    }

    set circle(value: string) {
        this.setAttribute("circle", value);
    }

    // get circle(): string {
    //     return this.getAttribute("circle") ?? "none";
    // }

    // set circle(value: "bronze" | "silver" | "mithril" | "gold" | "platinum") {
    //     this.setAttribute("circle", value);
    // }

    get token(): string {
        return this.getAttribute("token") ?? "none";
    }

    set token(value: "none" | "kiitos" | "kiitti" | "cash" | "stablecoin") {
        this.setAttribute("token", value);
    }

    async attributeChangedCallback(
        name: string,
        oldValue: string | null,
        newValue: string | null
    ) {
        switch (name) {
            case "uid":
                if (newValue) {
                    const profile = await this.me.getUserProfile(newValue);

                    this.name.textContent = getName(profile); // deprecated
                    // this.circle = profile.phoneNumber ? "mithril" : "silver";
                    // this.aura = "skyblue";

                    this.photo.style.borderColor = getKiitosAuraColor(
                        profile.kiitosFrequency || 0
                    );
                    this.photo.style.borderWidth = getKiitosAuraSize(
                        profile.kiitosFrequency || 0,
                        "m"
                    );
                    this.photo.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
                    // this.photo.classList.add(
                    //     getKiittiAuraColor(profile.kiittiFrequency || 0),
                    //     getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")
                    // );

                    this.photo.style.background = getAuraColor(
                        profile.kiitosFrequency || 0,
                        profile.kiittiFrequency || 0
                    );

                    this.photo.src = profile.photoURL || avatar;
                    // this.avatarYes.classList.toggle(
                    //     "hidden",
                    //     !profile.photoURL
                    // );
                } else this.render(this.heartbank.user);
                break;
            case "aura":
                if (newValue) {
                    //this.auraCircle.style.fill = newValue;
                    this.photo.style.backgroundColor = newValue;
                }
                break;
            case "circle": // TODO: better colors
                switch (newValue) {
                    case "bronze": // not logged in: iron, tungsten
                        //this.avatarNo.style.backgroundColor = "gray";
                        this.photo.style.borderColor = "transparent";
                        break;
                    case "silver": // email verified
                        //this.avatarNo.style.backgroundColor = "silver";
                        this.photo.style.borderColor = "silver";
                        break;
                    case "mithril": // phone verified: copper
                        //this.avatarNo.style.backgroundColor = "red";
                        this.photo.style.borderColor = "red";
                        break;
                    case "gold": // paid individual
                        //this.avatarNo.style.backgroundColor = "gold";
                        this.photo.style.borderColor = "gold";
                        break;
                    case "platinum": // paid org: id verified
                        //this.avatarNo.style.backgroundColor = "gold";
                        this.photo.style.borderColor = "gold";
                        break;
                }
                break;
            case "ring": // TODO: better colors
                switch (newValue) {
                    case "none":
                        //this.noAqua.style.borderColor = "white";
                        this.yesAqua.style.borderColor = "white";
                        break;
                    case "cash":
                        //this.noAqua.style.borderColor = "indigo";
                        this.yesAqua.style.borderColor = "indigo";
                        break;
                    case "iou":
                        //this.noAqua.style.borderColor = "silver";
                        this.yesAqua.style.borderColor = "silver";
                        break;
                }
                // if (this.ring) {
                //     this.avatarNo.classList.add(
                //         "bg-gray-100",
                //         "dark:bg-gray-400"
                //     );
                //     this.photo.classList.add("border-5", "border-white");
                // } else {
                //     this.avatarNo.classList.remove(
                //         "bg-gray-100",
                //         "dark:bg-gray-400"
                //     );
                //     this.photo.classList.remove("border-5", "border-white");
                // }
                break;
            case "token": //TODO: better colors
                //const noKiitos = this.noAqua.children[0] as SVGElement;
                //const noKiitti = this.noAqua.children[1] as SVGElement;
                //const noCash = this.noAqua.children[2] as SVGElement;

                //noKiitos.classList.add("hidden");
                //noKiitti.classList.add("hidden");
                //noCash.classList.add("hidden");

                const yesKiitos = this.yesAqua.children[0] as SVGElement;
                const yesKiitti = this.yesAqua.children[1] as SVGElement;
                const yesCash = this.yesAqua.children[2] as SVGElement;

                yesKiitos.classList.add("hidden");
                yesKiitti.classList.add("hidden");
                yesCash.classList.add("hidden");

                switch (newValue) {
                    case "none":
                        this.yesAqua.classList.remove("inline-flex");
                        //this.noAqua.classList.remove("inline-flex");
                        this.yesAqua.classList.add("hidden");
                        //this.noAqua.classList.add("hidden");
                        break;
                    case "kiitos":
                        this.yesAqua.classList.add("inline-flex");
                        //this.noAqua.classList.add("inline-flex");
                        this.yesAqua.classList.remove("hidden");
                        //this.noAqua.classList.remove("hidden");

                        yesKiitos.classList.remove("hidden");
                        //noKiitos.classList.remove("hidden");
                        this.yesAqua.style.backgroundColor = "violet";
                        //this.noAqua.style.backgroundColor = "violet";
                        break;
                    case "kiitti":
                        this.yesAqua.classList.add("inline-flex");
                        //this.noAqua.classList.add("inline-flex");
                        this.yesAqua.classList.remove("hidden");
                        //this.noAqua.classList.remove("hidden");

                        yesKiitti.classList.remove("hidden");
                        //noKiitti.classList.remove("hidden");
                        this.yesAqua.style.backgroundColor = "blue";
                        //this.noAqua.style.backgroundColor = "blue";
                        break;
                    case "cash":
                        this.yesAqua.classList.add("inline-flex");
                        //this.noAqua.classList.add("inline-flex");
                        this.yesAqua.classList.remove("hidden");
                        //this.noAqua.classList.remove("hidden");

                        yesCash.classList.remove("hidden");
                        //noCash.classList.remove("hidden");
                        this.yesAqua.style.backgroundColor = "green";
                        //this.noAqua.style.backgroundColor = "green";
                        break;
                    case "stablecoin":
                        this.yesAqua.classList.add("inline-flex");
                        //this.noAqua.classList.add("inline-flex");
                        this.yesAqua.classList.remove("hidden");
                        //this.noAqua.classList.remove("hidden");

                        yesCash.classList.remove("hidden");
                        //noCash.classList.remove("hidden");
                        this.yesAqua.style.backgroundColor = "orange";
                        //this.noAqua.style.backgroundColor = "orange";
                        break;
                }
        }
    }

    render(user: User | string | null) {
        typeof user === "string"
            ? this.renderProfile(user)
            : this.renderUser(user);
    }

    updatePhoto(url: string) {
        this.photo.src = url;
    }

    private async renderUser(user: User | null) {
        if (user) {
            const profile = await this.me.getUserProfile(user.uid);
            this.name.textContent = getName(); // deprecated
            //this.circle = user.phoneNumber ? "mithril" : "silver";
            //this.aura = "skyblue";
            //this.token = "cash";
            //this.ring = "iou";

            this.photo.style.borderColor = getKiitosAuraColor(
                profile.kiitosFrequency || 0
            );
            this.photo.style.borderWidth = getKiitosAuraSize(
                profile.kiitosFrequency || 0,
                "m"
            );
            this.photo.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
            // this.photo.classList.add(
            //     getKiittiAuraColor(profile.kiittiFrequency || 0),
            //     getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")
            // );
            this.photo.style.background = getAuraColor(
                profile.kiitosFrequency || 0,
                profile.kiittiFrequency || 0
            );

            this.photo.src = user.photoURL || avatar;
            //this.avatarYes.classList.toggle("hidden", !user.photoURL);

            // if (user.photoURL) {
            //     this.avatarYes.classList.remove("hidden");
            //     //this.avatarNo.classList.add("hidden");
            //     this.photo.src = user.photoURL;
            // } else {
            //     this.avatarYes.classList.remove("hidden"); //add
            //     //this.avatarNo.classList.remove("hidden");
            //     this.photo.src = avatar;
            // }
        } else this.renderAnonymous();
    }

    // when minting, it's possible to be anonymous and show aura
    // when mining, it's impossible to be anonymous and show aura
    private async renderProfile(key: string) {
        const profile = await this.me.getProfile(key);
        if (profile) {
            this.name.textContent = getName(profile); // deprecated
            //this.circle = profile.phoneNumber ? "mithril" : "silver";
            //this.aura = "skyblue";
            //this.token = "cash";
            //this.ring = "iou";

            this.photo.style.borderColor = getKiitosAuraColor(
                profile.kiitosFrequency || 0
            );
            this.photo.style.borderWidth = getKiitosAuraSize(
                profile.kiitosFrequency || 0,
                "m"
            );
            this.photo.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
            // this.photo.classList.add(
            //     getKiittiAuraColor(profile.kiittiFrequency || 0),
            //     getKiittiAuraSize(profile.kiittiAmplitude || 0, "m")
            // );
            this.photo.style.background = getAuraColor(
                profile.kiitosFrequency || 0,
                profile.kiittiFrequency || 0
            );

            this.photo.src = profile.photoURL || avatar; // public
            //this.avatarYes.classList.toggle("hidden", !profile.photoURL);
        } else this.renderAnonymous();
    }

    private async renderAnonymous() {
        this.name.textContent = "Anonymous"; // deprecated
        this.circle = "gray"; // "bronze";
        this.aura = "silver"; // "transparent";
        //this.token = "cash";
        //this.ring = "iou";

        this.photo.src = getRandomAvatarUrl();
        //this.avatarYes.classList.toggle("hidden", false);
    }

    // not used
    show() {
        this.classList.remove("hidden");
    }

    // not used
    hide() {
        this.classList.add("hidden");
    }
}
